import InvoiceCard from 'components/InvoiceCard';
import PageContainer from 'components/PageContainer';
import React from 'react';

import CardLimit from './CardLimit';
import { SectionContainer } from './styles';

const Main: React.FC = () => {
  return (
    <PageContainer>
      <SectionContainer>
        <InvoiceCard title="Fatura e pagamento" />
      </SectionContainer>
      <SectionContainer>
        <CardLimit title="Limite do meu cartão" />
      </SectionContainer>
    </PageContainer>
  );
};

export default Main;
